import m from 'mithril'
import ContentPage from 'views/pages/contentpage'
import {WysiwygType} from 'types/types'
import {t} from 'store'

import './about.less'
import Wysiwyg from 'views/layout/wysiwyg'
import {classes} from '@codeurs/front'
import Link from 'views/layout/link'

type JobType = {
	title: string
	description: WysiwygType
	email_info: string
	email: string
}

export default class About extends ContentPage<{
	jobs: Array<JobType>
}> {
	viewContent() {
		return this.viewJobs()
	}

	viewJobs() {
		const {jobs} = this.attrs.data
		return m('.about-jobs#jobs', [
			m('h2.about-jobs-title', t('about.jobs.title')),
			jobs.length
				? jobs.map(job => this.viewJob(job))
				: m('.about-jobs-empty', t('about.jobs.empty'))
		])
	}
	viewJob(job: JobType) {
		return m('.about-jobs-job', [
			m('.about-jobs-job-title', job.title),
			m(Wysiwyg, {html: job.description, mod: 'dark'}),
			m('.about-jobs-job-info', [
				m('.about-jobs-job-info-text', job.email_info),
				m(Link,
					{
						href: `mailto:${job.email}`,
						class: 'about-jobs-job-info-email',
						mod: 'mailto'
					},
					job.email
				)
			])
		])
	}
}
